// extracted by mini-css-extract-plugin
export default {"link":"NavigationLink__link--lc-YRuO5","component":"NavigationBlock__component--lc-LF3jV","list":"NavigationBlock__list--lc-p4nSV","item":"NavigationBlock__item--lc-N1DYZ"};